import { ReactNode } from 'react';
import styles from './AppContent.module.scss';

const AppContent = ({ children }: { children: ReactNode }) => <div className={styles.content}>{children}</div>;

export { AppContent };
